import Raven from "raven-js";

if (IS_PRODUCTION) {
    Raven.config("https://46ed4bba334c40d3b41e84a066b7bebd@s.crutches.space/87").install();
}

import Gdpr from "./../gdpr";
import { requireScript } from "./../helpers/require-script";
require("./../helpers/header-scroll-up");
import documentReady from "./../helpers/document-ready";
import LazyLoad from "vanilla-lazyload";
import setGAEvents from "../helpers/setGAEvents";

console.log(
    "👩‍💻 Hello there! Interested in our stack? Instead of peeking, why not work with us? Check https://tapfiliate.com/careers/ 👨‍💻",
);

requireScript("https://js.stripe.com/v3/");

documentReady(() => {
    new LazyLoad({
        elements_selector: ".j-lazy-load",
    });

    const urlParams = new URLSearchParams(window.location.search);
    let openChat = urlParams.get("chat") === "true";
    if (openChat) {
        // Wait for Intercom to boot (max 10 seconds)
        const timeout = setTimeout(() => clearInterval(interval), 10000);
        const interval = setInterval(() => {
            if (Intercom && Intercom.booted) {
                Intercom("show");
                clearInterval(interval);
                clearTimeout(timeout);
            }
        }, 100);
    }

    setGAEvents();

    (function() {
        const intercomAppId = "zqoydfja";
        var w = window;
        var ic = w.Intercom;
        if (typeof ic === "function") {
            ic('reattach_activator');
            ic('update', {
                app_id: intercomAppId
            });
        } else {
            var d = document;
            var i = function() {
                i.c(arguments)
            };
            i.q = [];
            i.c = function(args) {
                i.q.push(args)
            };
            w.Intercom = i;

            var l = function() {
                var s = d.createElement('script');
                s.type = 'text/javascript';
                s.async = true;
                s.src = `https://widget.intercom.io/widget/${intercomAppId}`;
                s.onload = function() {
                    if (typeof w.Intercom === "function") {
                        w.Intercom('update', {
                            app_id: intercomAppId
                        });
                    } else {
                        console.error('Intercom script failed to initialize.');
                    }
                };
                var x = d.getElementsByTagName('script')[0];
                x.parentNode.insertBefore(s, x);
            }
            if (w.attachEvent) {
                w.attachEvent('onload', l);
            } else {
                w.addEventListener('load', l, false);
            }
        }
    })()

});

